























































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import {
  required,
  maxLength,
  requiredIf,
  ValidationRule,
} from 'vuelidate/lib/validators'
import Button from '@/app/ui/components/Button/index.vue'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'
import MarketplaceTextInput from '../../components/MarketplaceTextInput/index.vue'
import MarketplaceDropdown from '../../components/MarketplaceDropdown/index.vue'
import ModalConfirm from '../../components/MarketplaceModal/ModalConfirm.vue'
import ModalSuccess from '../../components/MarketplaceModal/ModalSuccess.vue'
import ModalCourierNotFound from '../../components/MarketplaceModal/ModalCourierNotFound.vue'
import POSController from '@/app/ui/controllers/POSController'
import PODController from '@/app/ui/controllers/PODTrackerController'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import { POS } from '@/domain/entities/POS'
import { LocalStorage, Utils } from '@/app/infrastructures/misc'
import {
  MAX_NAME_WHITE_SELLER,
  MAX_PHONE_NUMBER_WHITE_SELLER,
} from '@/app/infrastructures/misc/Constants/validation'
import { Courier } from '@/domain/entities/Courier'
import MarketplaceInputPhone from '../../components/MarketplaceInputPhone/index.vue'
import MarketplaceRadioButton from '../../components/MarketplaceRadioButton/index.vue'
import { PODTrackerDriver } from '@/domain/entities/PODTracker'
import { WhiteSeller } from '@/domain/entities/WhiteSeller'
import { ShowSellerPhoneRequest } from '@/data/payload/api/WhiteSellerRequest'

interface OptionsNumber {
  label: string
  value: number
}

interface OptionsString {
  label: string
  value: string
}

interface IValidations {
  form: {
    name: {
      required: () => ValidationRule
      maxLength: ValidationRule
    }
    phone: {
      required: () => ValidationRule
      maxLength: () => boolean
      minLength: () => boolean
    }
    status: {
      required: () => ValidationRule
    }
    agentId: {
      required: ValidationRule
    }
    sellerRole: {
      required: () => ValidationRule
    },
    courierId: {
      required: ValidationRule
    }
    assignType: {
      required: ValidationRule
    }
  }
}

@Component({
  mixins: [validationMixin],
  components: {
    Button,
    DropdownSelect,
    MarketplaceTextInput,
    MarketplaceDropdown,
    ModalConfirm,
    ModalSuccess,
    ModalCourierNotFound,
    MarketplaceInputPhone,
    MarketplaceRadioButton
  },
})
class EditSellerWhitelist extends Vue {
  POSController = POSController
  PODController = PODController
  WhiteSellerController = WhiteSellerController
  modalEditConfirm = false
  modalSuccessAdd = false
  modalCRRNFD = false
  statusOptions = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]
  sellerRoleOptions = [
    { label: 'TOKOPEDIA', value: 'TOKOPEDIA' },
    { label: 'BUKALAPAK', value: 'BUKALAPAK' },
    { label: 'MERCHANT', value: 'MERCHANT' },
    { label: 'CLIENT', value: 'CLIENT' },
  ]
  codHandlingOptions = [
    {
      label: 'specialcod',
      value: 'specialcod',
    },
    {
      label: 'standardcod',
      value: 'standardcod',
    },
  ]
  partnerPOSOptions = <OptionsNumber[]>[]
  driverListOptions = <OptionsString[]>[]
  currentAgent = null as any
  form = {
    id: 0,
    name: '',
    phone: '',
    status: this.statusOptions[0],
    agentId: 0 as any,
    sellerRole: [] as Record<string, any>,
    codHandling: [] as Record<string, any>,
    phoneCode: '',
    assignTo: '',
    courierId: '' as any,
    assignType: '' as any
  }
  currentPartnerId = 0
  parameters = {
    page: 1,
    per_page: 100,
    search: '',
    sort_by: 'ASC',
    filter_status: 'ACTIVE'
  }
  courierParameters = {
    page: 1,
    per_page: 100,
    q: '',
    sort_by: 'ASC',
    courier_status: 'ACTIVE',
    driver_type: ''
  }
  isStatusActive = true
  MAX_PHONE_NUMBER_WHITE_SELLER = MAX_PHONE_NUMBER_WHITE_SELLER
  MAX_NAME_WHITE_SELLER = MAX_NAME_WHITE_SELLER
  assignToOptions = [
    { label: 'POS', value: 'pos' },
    { label: 'Kurir', value: 'courier' }
  ]

  created(): void {
    this.fetchData()
  }

  get myAccessMenus(): string[] {
    return JSON.parse(
      LocalStorage.getLocalStorage(LocalStorage.ACCESS_MENU, true)
    )
  }

  get showCODHandlingDropdown(): boolean {
    return this.form.sellerRole.value === 'CLIENT'
  }

  get showPartnerPos(): boolean {
    return this.form.assignTo === 'pos'
  }

  private async fetchData(posOnly?: boolean) {
    await POSController.getPOSData(this.parameters)
    if (!posOnly) {
      WhiteSellerController.getDetail(this.$route.params.id)
    }
  }

  private onSearchPartnerPOS = Utils.debounce((keyword: string) => {
    if (keyword) {
      POSController.getPOSData({
        ...this.parameters,
        search: keyword,
      })
    }
  }, 500)

  private onSelectPartnerPOS(pos: OptionsNumber) {
    if (pos) POSController.getCourierList(String(pos.value))
  }

  private handleCancelModalCRRNFD() {
    this.modalCRRNFD = false
    this.form.agentId = this.currentAgent
  }

  private handleNewCourier() {
    if (this.myAccessMenus && this.myAccessMenus.includes('manage-courier')) {
      let routeData = this.$router.resolve({ name: 'CreateManageCourierPage' })
      window.open(routeData.href, '_blank')
    } else {
      this.form.agentId = []
      this.$notify({
        title: 'Forbidden Access',
        text: 'Please request access to admin',
        type: 'error',
        duration: 3000,
      })
      this.modalCRRNFD = false
    }
  }

  private onBackToList() {
    this.$router.push({ name: 'ManageWhitelist' })
  }

  private onSubmit() {
    const payload = {
      id: this.form.id,
      name: this.form.name,
      phone: `${this.form.phoneCode}${this.form.phone}`,
      status: this.form.status.value,
      agentId: this.form.agentId && this.form.agentId.value,
      role: this.form.sellerRole.value,
      codHandling: this.form.codHandling?.value,
      courierId: Number(this.form?.courierId?.value || 0) as any,
      assignType: this.form?.assignType?.value as any
    }

    if (this.form.sellerRole.value !== 'CLIENT') {
      delete payload.codHandling
    }

    if (this.showPartnerPos) {
      delete payload.assignType
      delete payload.courierId
    } else {
      delete payload.agentId
    }

    WhiteSellerController.updateWhiteSeller(payload)
  }

  private onPhoneCodeChange(phoneCode: string) {
    this.form.phoneCode = phoneCode
  }

  private maxLengthIndonesianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.phone.length <= 13
    }
    return true
  }

  private minLengthIndosianPhoneNumber(): boolean {
    if (this.form.phoneCode === '+62') {
      return this.form.phone.length >= 9
    }
    return true
  }

  private onSearchDriverList = Utils.debounce((keyword: string) => {
    const params = {
      ...this.courierParameters,
      q: this.replacePhoneNumber(keyword || '')
    }
    this.PODController.getDriverList(params)
  }, 500)
  private replacePhoneNumber(text: string): string {
    if (/^08([0-9]+)$/.test(text)) {
      return Utils.countryIndonesiaPhoneNumber(text).trim()
    }
    return text
  }
  get assignTypeOptions(): OptionsString[] {
    const items = [
      { label: 'Offer', value: 'OFFER' },
      { label: 'Auto Assign', value: 'AUTO ASSIGN' }
    ]
    return items
  }

  @Validations()
  validations(): IValidations {
    const isPosOrCourierRequired = this.isStatusActive
    const isAssignToPos = this.showPartnerPos
    return {
      form: {
        name: {
          required,
          maxLength: maxLength(MAX_NAME_WHITE_SELLER),
        },
        phone: {
          required,
          maxLength: this.maxLengthIndonesianPhoneNumber,
          minLength: this.minLengthIndosianPhoneNumber,
        },
        status: { required },
        agentId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && isAssignToPos
          }),
        },
        sellerRole: { required },
        courierId: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
        assignType: {
          required: requiredIf(function() {
            return isPosOrCourierRequired && !isAssignToPos
          })
        },
      },
    }
  }

  @Watch('POSController.posData')
  setPOSPartner(data: POS[]): void {
    const POSOptions = data.map(item => {
      return {
        label: `${item.name} [${item.code}]`,
        value: item.id,
      }
    }) as OptionsNumber[]
    this.partnerPOSOptions = POSOptions
    const currentPOS = <OptionsNumber>(
      POSOptions.find(item => item.value === this.currentPartnerId)
    )
    if(currentPOS) {
      this.form.agentId = currentPOS
    }
    if(!this.currentAgent) {
      this.currentAgent = currentPOS
    }
    this.onSelectPartnerPOS(currentPOS)
  }

  @Watch('POSController.posCourier')
  setPOSCourier(data: Courier[]): void {
    if (data && data.length === 0) {
      this.modalCRRNFD = true
    }
  }

  @Watch('WhiteSellerController.dataWhiteSeller')
  async updateForm(val: WhiteSeller): Promise<void> {
    if (val) {
      this.parameters = {
        ...this.parameters,
        search: <string>val.partnerPOS,
      }
      this.currentPartnerId = <number>val.partnerId
      await this.fetchData(true)
      const phoneResp = await WhiteSellerController.showWhitelistSellerPhone(new ShowSellerPhoneRequest({
        id: val.id,
        source: "whitelist-edit",
        type: val.role
      }));
      let courierLabel = `${val.courierId} - ${val.courierName}`

      if (val.courierId) {
        this.courierParameters.q = val.courierName || "";
        await this.PODController.getDriverList(this.courierParameters)
        this.courierParameters.q = "";
        const courierData = this.PODController.driverData.find(driver => driver.courierId === val.courierId);
        if (courierData) courierLabel = `[${courierData.courierId}] ${courierData.fullname} (${courierData.announcementCourierType}) ${courierData.phoneNumber} • ${courierData.partnerName}`;
      }


      this.form = {
        id: <number>val.id,
        name: <string>val.name || '',
        phone: phoneResp.phone,
        status: <OptionsString>(
          this.statusOptions.find(item => item.value === val.status)
        ),
        agentId: val.partnerId ? { label: `${val.partnerPOS} [${val.partnerCode}]`, value: val.partnerId } : '',
        sellerRole:
          this.sellerRoleOptions.find(item => item.label === val.role) || [],
        codHandling:
          this.codHandlingOptions.find(
            item => item.value === val.codHandling
          ) || [],
        phoneCode: '',
        assignTo: val.courierId ? 'courier' : 'pos',
        courierId: val.courierId  ? { label: courierLabel, value: val.courierId } : '',
        assignType: this.assignTypeOptions.find(item => item.value === val.assignType)
      }

      await PODController.getDriverList(this.courierParameters)
    }
  }

  @Watch('PODController.driverData')
  setDriverList(data: PODTrackerDriver[]): void {
    const DriverOption = data.map(item => {
      const label = `[${item.courierId}] ${item.fullname} (${item.announcementCourierType}) ${item.phoneNumber} • ${item.partnerName}`
      return {
        label,
        value: item.courierId?.toString()
      }
    }) as OptionsString[]
    this.driverListOptions = DriverOption
  }

  @Watch('form.status')
  onStatusChange(status: OptionsString): void {
    // Set Partner POS or Courier Required
    if (status.value === 'ACTIVE') {
      this.isStatusActive = true
    } else {
      this.isStatusActive = false
    }
  }

  @Watch('WhiteSellerController.isEditWhiteSellerSuccess')
  onEditWhiteSellerSuccess(val: boolean): void {
    if (val) {
      this.modalEditConfirm = false
      this.modalSuccessAdd = val
    }
  }

  @Watch('form.name')
  setSellerName(data: string): void {
    // remove script tag
    this.form.name = Utils.removeScriptTags(data)

    // remove special character
    this.form.name = Utils.removeSpecialCharacters(this.form.name)

    // remove html tag
    this.form.name = Utils.removeHTMLTags(this.form.name)
  }

  beforeDestroy(): void {
    this.WhiteSellerController.setIsEditWhiteSellerSuccess(false)
  }
}

export default EditSellerWhitelist;
